import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import ModuleRoute from './components/auth/ModuleRoute';
import DashboardLayout from './components/layouts/DashboardLayout';
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import LeadsPage from './pages/leads/LeadsPage';
import LeadDetailPage from './pages/leads/LeadDetailPage';
import PropertiesPage from './pages/properties/PropertiesPage';
import PropertyDetailPage from './pages/properties/PropertyDetailPage';
import OpportunitiesPage from './pages/opportunities/OpportunitiesPage';
import OpportunityDetailPage from './pages/opportunities/OpportunityDetailPage';
import MeetingsPage from './pages/meetings/MeetingsPage';
import MeetingDetailPage from './pages/meetings/MeetingDetailPage';
import BlogPostsPage from './pages/blog/BlogPostsPage';
import BlogPostDetailPage from './pages/blog/BlogPostDetailPage';
import AssetsPage from './pages/assets/AssetsPage';
import IntegrationsPage from './pages/integrations/IntegrationsPage';
import AvmPage from './pages/avm/AvmPage';
import ParticularsPage from './pages/particulares/ParticularsPage';
import UsersPage from './pages/users/UsersPage';
import UserDetailPage from './pages/users/UserDetailPage';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/:id" element={<LeadDetailPage />} />
        <Route path="properties" element={<PropertiesPage />} />
        <Route path="properties/:id" element={<PropertyDetailPage />} />
        <Route path="opportunities" element={<OpportunitiesPage />} />
        <Route path="opportunities/:id" element={<OpportunityDetailPage />} />
        <Route path="meetings" element={<MeetingsPage />} />
        <Route path="meetings/:id" element={<MeetingDetailPage />} />

        {/* Módulos con permiso */}
        <Route path="blog" element={<ModuleRoute module="blog"><BlogPostsPage /></ModuleRoute>} />
        <Route path="blog/:id" element={<ModuleRoute module="blog"><BlogPostDetailPage /></ModuleRoute>} />
        <Route path="assets" element={<ModuleRoute module="assets"><AssetsPage /></ModuleRoute>} />
        <Route path="integrations" element={<ModuleRoute module="integrations"><IntegrationsPage /></ModuleRoute>} />
        <Route path="avm" element={<ModuleRoute module="avm"><AvmPage /></ModuleRoute>} />
        <Route path="particulares" element={<ModuleRoute module="listado-particulares"><ParticularsPage /></ModuleRoute>} />

        {/* Solo ADMIN */}
        <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
        <Route path="users/:id" element={<AdminRoute><UserDetailPage /></AdminRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
